module.exports = __webpack_public_path__ + "img/bolt-slash.e7bb491c.svg";